import { lazy, Suspense } from "react";

// v76 — loaded only for the super admin, as its own chunk.
const Shortcuts = lazy(() => import("@/components/admin/ClientShortcuts"));

export function ClientShortcutSlot() {
  return <Suspense fallback={null}><Shortcuts /></Suspense>;
}
